/* Instagram homepage grid + lightbox. Vanilla, no deps.
   Fetches the PHP proxy (token never reaches the browser), renders a grid,
   opens an in-page lightbox. Hides the whole section if the feed is empty. */
(function () {
  'use strict';

  var IG_ICON = '<svg viewBox="0 0 24 24"><path d="M12 2c2.7 0 3 .01 4.1.06 1 .05 1.7.22 2.3.46.6.24 1.1.56 1.6 1.05.5.5.8 1 1.05 1.6.24.6.4 1.3.46 2.3.05 1.1.06 1.4.06 4.1s-.01 3-.06 4.1c-.05 1-.22 1.7-.46 2.3a4.6 4.6 0 0 1-1.05 1.6c-.5.5-1 .8-1.6 1.05-.6.24-1.3.4-2.3.46-1.1.05-1.4.06-4.1.06s-3-.01-4.1-.06c-1-.05-1.7-.22-2.3-.46a4.6 4.6 0 0 1-1.6-1.05c-.5-.5-.8-1-1.05-1.6-.24-.6-.4-1.3-.46-2.3C2.01 15 2 14.7 2 12s.01-3 .06-4.1c.05-1 .22-1.7.46-2.3.24-.6.56-1.1 1.05-1.6.5-.5 1-.8 1.6-1.05.6-.24 1.3-.4 2.3-.46C9 2.01 9.3 2 12 2zm0 1.8c-2.7 0-3 .01-4 .06-.8.04-1.2.17-1.5.29-.4.14-.6.31-.9.6-.3.3-.46.5-.6.9-.12.3-.25.7-.29 1.5-.05 1-.06 1.3-.06 4s.01 3 .06 4c.04.8.17 1.2.29 1.5.14.4.31.6.6.9.3.3.5.46.9.6.3.12.7.25 1.5.29 1 .05 1.3.06 4 .06s3-.01 4-.06c.8-.04 1.2-.17 1.5-.29.4-.14.6-.31.9-.6.3-.3.46-.5.6-.9.12-.3.25-.7.29-1.5.05-1 .06-1.3.06-4s-.01-3-.06-4c-.04-.8-.17-1.2-.29-1.5a2.5 2.5 0 0 0-.6-.9c-.3-.3-.5-.46-.9-.6-.3-.12-.7-.25-1.5-.29-1-.05-1.3-.06-4-.06zM12 7.2a4.8 4.8 0 1 1 0 9.6 4.8 4.8 0 0 1 0-9.6zm0 1.8a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm5-2.3a1.1 1.1 0 1 1 0 2.2 1.1 1.1 0 0 1 0-2.2z"/></svg>';
  var PLAY_ICON = '<svg viewBox="0 0 24 24"><path d="M8 5v14l11-7z"/></svg>';

  function init(root) {
    if (!root || root.dataset.igInit) return;
    root.dataset.igInit = '1';
    var endpoint = root.getAttribute('data-ig-endpoint');
    var count = parseInt(root.getAttribute('data-ig-count'), 10) || 8;
    var grid = root.querySelector('.ig-grid__items');
    if (!endpoint || !grid) return;

    var url = endpoint + (endpoint.indexOf('?') > -1 ? '&' : '?') + 'limit=' + count;
    fetch(url, { credentials: 'omit' })
      .then(function (r) { return r.ok ? r.json() : { data: [] }; })
      .then(function (json) {
        var items = (json && json.data) || [];
        if (!items.length) { root.style.display = 'none'; return; }
        render(grid, items);
      })
      .catch(function () { root.style.display = 'none'; });
  }

  function render(grid, items) {
    grid.innerHTML = '';
    items.forEach(function (item, idx) {
      var cell = document.createElement('button');
      cell.type = 'button';
      cell.className = 'ig-cell';
      cell.setAttribute('role', 'listitem');
      cell.setAttribute('aria-label', item.caption ? item.caption.slice(0, 80) : 'Instagram post');

      var img = document.createElement('img');
      img.loading = 'lazy';
      img.src = item.thumb; // property assignment = no HTML injection
      img.alt = item.caption ? item.caption.slice(0, 120) : 'Instagram post';
      cell.appendChild(img);

      var ov = document.createElement('span');
      ov.className = 'ig-cell__overlay';
      ov.innerHTML = IG_ICON; // static, trusted markup
      cell.appendChild(ov);

      if (item.media_type === 'VIDEO') {
        var badge = document.createElement('span');
        badge.className = 'ig-cell__badge';
        badge.innerHTML = PLAY_ICON;
        cell.appendChild(badge);
      }

      cell.addEventListener('click', function () { openLightbox(items, idx); });
      grid.appendChild(cell);
    });
  }

  // ---- Single shared lightbox ----
  var lb, lbMedia, lbCaption, lbLink;
  var state = { items: [], i: 0 };

  function ensureLightbox() {
    if (lb) return;
    lb = document.createElement('div');
    lb.className = 'ig-lb';
    lb.innerHTML =
      '<button class="ig-lb__btn ig-lb__close" aria-label="Close">&times;</button>' +
      '<button class="ig-lb__btn ig-lb__prev" aria-label="Previous">&#8249;</button>' +
      '<button class="ig-lb__btn ig-lb__next" aria-label="Next">&#8250;</button>' +
      '<div class="ig-lb__box">' +
        '<div class="ig-lb__media"></div>' +
        '<div class="ig-lb__caption"></div>' +
        '<a class="ig-lb__link" target="_blank" rel="noopener">View on Instagram</a>' +
      '</div>';
    document.body.appendChild(lb);
    lbMedia = lb.querySelector('.ig-lb__media');
    lbCaption = lb.querySelector('.ig-lb__caption');
    lbLink = lb.querySelector('.ig-lb__link');
    lb.querySelector('.ig-lb__close').addEventListener('click', closeLightbox);
    lb.querySelector('.ig-lb__prev').addEventListener('click', function (e) { e.stopPropagation(); step(-1); });
    lb.querySelector('.ig-lb__next').addEventListener('click', function (e) { e.stopPropagation(); step(1); });
    lb.addEventListener('click', function (e) { if (e.target === lb) closeLightbox(); });
    document.addEventListener('keydown', function (e) {
      if (!lb.classList.contains('is-open')) return;
      if (e.key === 'Escape') closeLightbox();
      else if (e.key === 'ArrowLeft') step(-1);
      else if (e.key === 'ArrowRight') step(1);
    });
  }

  function openLightbox(items, i) {
    ensureLightbox();
    state.items = items;
    state.i = i;
    paint();
    lb.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeLightbox() {
    lb.classList.remove('is-open');
    lbMedia.innerHTML = '';
    document.body.style.overflow = '';
  }
  function step(d) {
    var n = state.items.length;
    if (!n) return;
    state.i = (state.i + d + n) % n;
    paint();
  }
  function paint() {
    var it = state.items[state.i];
    lbMedia.innerHTML = '';
    var el;
    if (it.media_type === 'VIDEO') {
      el = document.createElement('video');
      el.controls = true; el.autoplay = true; el.playsInline = true;
      el.src = it.full;
    } else {
      el = document.createElement('img');
      el.src = it.full; el.alt = '';
    }
    lbMedia.appendChild(el);
    lbCaption.textContent = it.caption || '';
    if (it.permalink) { lbLink.href = it.permalink; lbLink.style.display = ''; }
    else { lbLink.style.display = 'none'; }
  }

  function boot() {
    document.querySelectorAll('[data-ig-grid]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // Re-init when added/edited in the Shopify theme editor.
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target && e.target.querySelector ? e.target.querySelector('[data-ig-grid]') : null;
    if (el) init(el);
  });
})();
